import { TimeDimensionGranularity } from '@cubejs-client/core';
import moment from 'moment';
import { formatBigAmount, formatAmount } from 'app/utils/parsers';
import { QueryBuilderRenderProps } from '@cubejs-client/react';
import LineGraphBase from '../LineGraphBase';

export default class TeammoPaymentsGraph extends LineGraphBase {
  // graphType = 'large';

    graphName = () => ''

    xAxisFormatter = (label) => moment(label).format('DD MMM')

    yAxisFormatter = (label) => formatBigAmount(label)

    labelFormatter = (label) => moment(label).format('DD MMM YYYY')

    formatter = (label, name, props) => [formatAmount(label), 'Amount']

    query = () => ({
      measures: [
        'PaymentVolume.totalCollectedAllPaymentsInDollars',
      ],
      timeDimensions: [
        {
          dimension: 'PaymentVolume.dateDay',
          granularity: 'day' as TimeDimensionGranularity,
          dateRange: this.props?.timePeriod,
        },
      ],
      order: {},
      filters: [
        {
          dimension: 'PaymentVolume.organisationId',
          operator: 'equals',
          values: [
            this.props.organisationId,
          ],
        },
        // {
        //   dimension: 'PaymentVolume.competitionId',
        //   operator: 'equals',
        //   values: [
        //     this.props.competitionId,
        //   ],
        // },
      ],
    })
}
